import React from 'react';
import { useDimensions } from '../../contexts/DimensionContext';
import { useBook } from '../../contexts/BookContext';
import { PAGE_SIZES } from '../../constants/pageSizes';
import './PageSizeSelector.css';

/**
 * Component for selecting different page sizes
 * This connects to the DimensionContext to make page size changes book-specific
 * @param {Object} props
 * @param {string} [props.bookId] - Optional book ID to override context
 * @param {Function} [props.onPageSizeChange] - Optional callback when page size changes
 */
const PageSizeSelector = ({ bookId: propBookId, onPageSizeChange }) => {
  // Get context values
  const { selectedPageSize, updatePageSize, currentBookId } = useDimensions();
  const { currentBook } = useBook();
  
  // Get the current book ID from props first, then context, then book context
  const bookId = propBookId || currentBookId || (currentBook && currentBook.id);
  
  // Handle selection change
  const handlePageSizeChange = (event) => {
    const newSize = event.target.value;
    console.log(`PageSizeSelector: Changing page size to: ${newSize} for book: ${bookId || 'unknown'}`);
    
    // First call the custom handler if provided (allow parent component to handle the change)
    if (onPageSizeChange) {
      onPageSizeChange(newSize);
    }
    // Also update through the context to ensure consistency
    else {
      updatePageSize(newSize, bookId);
    }  
  };
  
  return (
    <div className="page-size-selector flex flex-row items-center">
      <label htmlFor="page-size" className="mr-3 text-sm font-medium text-gray-700">Page Size</label>
      <div className="select-container">
        <select 
          id="page-size" 
          value={selectedPageSize} 
          onChange={handlePageSizeChange}
          className="page-size-select py-2"
        >
          {Object.entries(PAGE_SIZES).map(([key, size]) => (
            <option key={key} value={key}>
              {size.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PageSizeSelector;
